var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"editar-carpeta","title":"Editar carpeta"},on:{"close":() => _vm.close(false)}},[_c('FormCarpeta',{attrs:{"loading":_vm.loading,"carpeta":_vm.carpeta},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }